module.exports = __webpack_public_path__ + "static/media/bags_in_a_van.3c79e900.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/bags_in_a_van.svg
// module id = 617
// module chunks = 0